/**
 * DevExtreme (esm/__internal/scheduler/workspaces/m_work_space_work_week.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../../core/component_registrator";
import { getWeekendsCount } from "../../scheduler/r1/utils/index";
import { VIEWS } from "../utils/options/constants_view";
import SchedulerWorkSpaceWeek from "./m_work_space_week";
const WORK_WEEK_CLASS = "dx-scheduler-work-space-work-week";
class SchedulerWorkSpaceWorkWeek extends SchedulerWorkSpaceWeek {
  get type() {
    return VIEWS.WORK_WEEK;
  }
  constructor() {
    super(...arguments);
    this._getWeekendsCount = getWeekendsCount;
  }
  _getElementClass() {
    return WORK_WEEK_CLASS;
  }
}
registerComponent("dxSchedulerWorkSpaceWorkWeek", SchedulerWorkSpaceWorkWeek);
export default SchedulerWorkSpaceWorkWeek;